import styled from 'styled-components'
import { Form } from 'lib/ui/components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import { link } from 'app/sofia/resources/theme/css'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 30px 30px 80px;
  ${bp('sm')`
    padding: 20px 15px 60px;
  `}

  h1 {
    font: ${font('default', 'medium', '28px')};
    text-align: left;
    margin: 20px 0 40px;
  }

  h2 {
    font: ${font('default', 'medium', '20px')};
    margin: 15px 0 30px;
  }

  form {
    margin: 0 auto;

    label {
      font-size: 18px;
    }
  }

  ${Form.Actions.Styled} {
    margin: 30px 0 0;
    padding: 30px 0 0;
    border-top: 1px solid ${props => props.theme.form.passiveColor};
    ${bp('sm')`
      padding-bottom: 60px;
    `}

    button {
      font-size: 18px;
      align-items: center;
      ${bp('sm')`
        width: 100%;
      `}
    }
  }

  .linkWrapper {
    a {
      display: inline-block;
      font: ${font('default', 'bold', '16px/1.5')};
      ${link}
      text-decoration: none;
      padding: 15px 0;
    }
  }

  .outlined {
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'medium', '18px/1')};
    border-color: ${props => props.theme.palette.primary.alphaDark};
    transition: background 300ms ease, opacity 300ms ease;

    &:hover {
      background-color: ${props => props.theme.palette.primary.alphaDark};
      color: ${props => props.theme.palette.general.light};
    }

    &:active {
      background-color: ${props => props.theme.palette.general.greyDark};
      border-color: ${props => props.theme.palette.general.greyDark};
      color: ${props => props.theme.palette.general.light};
    }
  }
`

export const CheckoutLayout = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  .cart__heading {
    text-align: left;
    font: ${font('default', 'bold', '18px/1')};
    color: ${props => props.theme.palette.general.strong};
    background: ${props => props.theme.palette.general.greyLight};
    text-transform: uppercase;
    padding: 10px;
  }
`

export const CheckoutMain = styled.div`
  width: calc(100% - 340px);
  padding: 0 30px 0 0;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINT.MD}) {
    width: 100%;
  }

  ${bp('sm')`
    width: 100%;
    padding: 0;
  `}

  button {
    &.livButton {
      background: ${props => props.theme.palette.primary.alpha};

      > div {
        font-weight: bold;
        text-transform: uppercase;
      }

      :hover {
        background: ${props => props.theme.palette.primary.alphaDark};
      }
    }
  }
`

export const ContentHeader = styled.div`
  text-align: left;
  font: ${font('default', 'bold', '18px/1')};
  color: ${props => props.theme.palette.general.strong};
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  text-transform: uppercase;
  padding: 10px;
`

export const ShippingFirstContent = styled.div`
  display: flex;
  margin-top: 30px;
  justify-content: space-between;

  &.full-content {
    display: block;
    max-width: 500px;
    margin: 30px auto auto;

    .general-content {
      padding: 0 !important;

      > div {
        width: 100% !important;
      }
    }
  }

  .accountLogin {
    margin-right: 5%;
  }

  .newCustomer {
    margin-right: 10%;
    max-width: 400px;

    .guest-checkout {
      font: ${font('default', 'bold', '14px/1')};
      color: ${props => props.theme.palette.primary.alphaDark};
      transition: all ease-in-out 0.3s;
      padding: 15px 0;
      background: none;
      border: none;
      cursor: pointer;

      &:hover {
        color: ${props => props.theme.palette.primary.alpha};
      }
    }
  }

  .create-account {
    background: none;
    padding: 0;
  }
`

export const ShippingFormContainer = styled.div`
  button {
    margin: auto;
  }

  form > div:nth-last-child(1) {
    margin: 0;
    border: 0;
  }
`
